import React from "react";
import CategoryPage from "./CategoryPage";

function Sports({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Sports"
      parentCategory="Articles"
      posts={posts}
      publications={publications}
    />
  );

}

export default Sports;